module.exports = __webpack_public_path__ + "00_mole.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/00_mole.png
// module id = r5E0
// module chunks = 0